export default __webpack_public_path__ + "static/media/buy_gmx_bond.ed3174dc.svg";